var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('el-link',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("备案号:湘ICP备2022022791号-1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }